<template>
  <div :style="`height: ${height}px;-webkit-overflow-scrolling: touch;overflow-y: scroll;`">
    <v-container v-if="!showBannder" grid-list-sm fluid>
      <v-row style="justify-content: center;">
        <v-col
          :cols="images.length === 1 ? 12 : 6"
          md="6"
          v-for="(item, index) in images"
          :key="'list' + index"
        >
          <v-img style="margin-top: 7vh;" :src="item"></v-img>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      v-else
      grid-list-sm
      fluid
      :class="{ containerPC: $store.state.ui.os.isPC }"
    >
      <!-- barnner -->
      <swiper :options="swiperOption">
        <swiper-slide
          class="swiper-slide"
          v-for="(item, index) in banner"
          :key="'bannder' + index"
        >
          <template v-if="$store.state.ui.os.isPC">
            <v-img
              :src="`${$store.state.galleryUrl}${item}`"
              contain
              height="500"
            ></v-img>
          </template>
          <template v-else>
            <v-img
              :src="`${$store.state.galleryUrl}${item}`"
              contain
              height="200"
            ></v-img>
          </template>
        </swiper-slide>
        <div
          class="swiper-pagination"
          :class="{ offsetTop: !$store.state.ui.os.isPC }"
          slot="pagination"
        ></div>
      </swiper>
    </v-container>
    <v-row style="margin-top: 12px;" v-if="$store.state.ui.os.isPC">
      <v-spacer></v-spacer>
      <v-btn
        dark
        large
        @click="startDesign(0)"
        class="text-capitalize mx-auto mb-2"
        min-width="200"
      >
        傘のデザインを開始
      </v-btn>
      <!-- <v-btn
        dark
        large
        @click="startDesign(1)"
        class="text-capitalize mx-auto mb-2 ml-2"
        min-width="200"
      >
        スカーフのデザインを開始
      </v-btn>
      <v-btn
        dark
        large
        @click="startDesign(2)"
        class="text-capitalize mx-auto mb-2 ml-2"
        min-width="200"
      >
        帽子のデザインを開始
      </v-btn> -->
      <v-spacer></v-spacer>
    </v-row>
    <v-col v-else style="text-align: center;">
      <v-spacer></v-spacer>
      <v-btn
        dark
        large
        @click="startDesign(0)"
        class="text-capitalize mx-auto mb-2"
        width="220"
      >
        傘のデザインを開始
      </v-btn>
      <!-- <v-btn
        dark
        large
        @click="startDesign(1)"
        class="text-capitalize mx-auto mb-2"
        width="220"
      >
        スカーフのデザインを開始
      </v-btn>
      <v-btn
        dark
        large
        @click="startDesign(2)"
        class="text-capitalize mx-auto mb-2"
        width="220"
      >
        帽子のデザインを開始
      </v-btn> -->
      <v-spacer></v-spacer>
    </v-col>
  </div>
</template>

<script>
export default {
  data () {
    return {
      height: window.innerHeight,
      swiperOption: {
        // 显示分页
        pagination: {
          el: '.swiper-pagination'
        },
        effect: 'fade',
        // 开启循环模式
        loop: false,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
      }
    }
  },
  computed: {
    images () {
      return [
        require('@/assets/images/logo.png')
      ]
    },
    showBannder () {
      if (this.$store.state.data && this.$store.state.data.banner) {
        return true
      } else {
        return false
      }
    },
    banner () {
      if (this.$store.state.data) {
        return this.$store.state.data.banner || []
      } else {
        return []
      }
    }
  },
  methods: {
    startDesign (index) {
      this.$store.state.ui.homeIndex = index
      if (index === 0) {
        this.$router.push('/umb')
      } else if (index === 1) {
        this.$router.push('/scarf')
      } else if (index === 2) {
        this.$router.push('/cap')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
}
.contentPC {
  width: 33.33vw;
  margin-left: 33.33vw;
}
.offsetTop {
  bottom: 0;
}
.containerPC {
  width: 500px;
}
</style>
